<template>
  <div class="shipmap-container">
    <div class="shipmap-wrap">
      <ship-map :points="trajectories" :center="center" />
    </div>

    <div class="ship-control">
      <el-tabs v-model="activetab" type="border-card">
        <el-tab-pane name="search" label="查询">
          <search-tab
            ref="searchtab"
            @trajectories="ontrajectories"
            @center="setcenter"
          />
        </el-tab-pane>
        <el-tab-pane
          name="warn"
          :label="`警告` + (warncount ? `(${warncount})` : '')"
        >
          <warn-tab
            ref="warn"
            @lookup="onlookup"
            @count="c => (warncount = c)"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ShipMap from './ShipMap.vue'
import SearchTab from './SearchTab.vue'
import WarnTab from './WarnTab.vue'
import request from '@/mixins/request'

import { div } from './maputil'

export default {
  components: {
    ShipMap,
    SearchTab,
    WarnTab,
  },

  mixins: [request],

  data() {
    return {
      activetab: 'search',

      trajectories: [],

      center: [0, 0],

      warncount: 0,
    }
  },

  watch: {
    activetab() {
      if (this.activetab === 'warn') {
        this.$refs.warn.$emit('activate')
        const searchtab = this.$refs.searchtab
        if (searchtab) {
          searchtab.$emit('deactivate')
        }
      }

      if (this.activetab === 'search') {
        this.$refs.searchtab.$emit('activate')
        const warn = this.$refs.warn
        if (warn) {
          warn.$emit('deactivate')
        }
      }
    },
  },

  async mounted() {
    const resp = await this.$api.get('/schedules/voyageops/countoutliners')

    if (resp.data.status === 1) {
      this.warncount = resp.data.content || 0
    }
  },

  methods: {
    ontrajectories(trajectories) {
      this.trajectories = trajectories || []
    },

    onlookup(row) {
      this.activetab = 'search'
      this.$nextTick(() =>
        this.$refs.searchtab.lookup(row.mmsi, row.begin, row.end)
      )
    },

    setcenter({ lon, lat }) {
      this.center = [div(lat), div(lon)]
    },
  },
}
</script>

<style lang="scss" scoped>
.shipmap-container {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .shipmap-wrap {
    position: absolute;
    left: 10px;
    top: 10px;
    right: 10px;
    bottom: 10px;
  }

  .ship-control {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 2000;
    width: 450px;
  }
}
</style>
>
